export const texts = {
  loginTitleSMS: "insira o código enviado por SMS",
  loginTitleEmail: "insira o código enviado por EMAIL",
  login: "Avançar",
  codePlaceholder: "código",
  noAccount: "não tem uma conta?",
  noAccountLink: "faça o cadastro aqui",
};
